import { render, staticRenderFns } from "./ReplacedQrReason.vue?vue&type=template&id=893fb7e6"
import script from "./ReplacedQrReason.vue?vue&type=script&lang=js"
export * from "./ReplacedQrReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports